import axios from "./orderInstance"

// define response type if known: e.g., type MachineApiResponse = ...
// define return type if known: e.g., type Machine[] = ...

export const getMachineList = async () => {
    try {
        const response: any = await axios(`/machines/`)


        if (!response) {
            console.error("No response from the server");
            return null;
        }

        return response.data
    } catch (error) {
        console.error("Error retrieving machine list:", error);

        return null;
    }
};

export default getMachineList;
